import { render, staticRenderFns } from "./CategorieList.vue?vue&type=template&id=6a7ad3b4&scoped=true&"
import script from "./CategorieList.vue?vue&type=script&lang=js&"
export * from "./CategorieList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ad3b4",
  null
  
)

export default component.exports